<template>
    <div class="page" id="affairMessageDetail">
        <div class="page-inner">
            <div class="page-header">
                <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
                <template v-if="status === 1">
                    <el-button @click="showDialog(1)" type="primary" size="medium">处理</el-button>
                    <el-button @click="showDialog(2)" v-show="source === 1" type="primary" size="medium">处理并通知提交人</el-button>
                </template>
                <template v-if="status === 2 && source === 1">
                    <el-button @click="notify" type="primary" size="medium">通知提交人</el-button>
                </template>
            </div>
            <div class="page-main" :style="{height: `${containerHeight}px`}">
                <div class="container">
                    <div class="section">
                        <div class="section-header">
                            <span class="color-block"></span>留言内容
                        </div>
                        <div class="section-content">
                            {{content}}
                            <div class="batch-info">
                                <span class="status">{{createUserName}}</span>
                                <span class="batch-time">{{mobile}}</span>
                                <span class="batch-user">{{createTime | trimTime}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="section" v-if="photo && photo.length !== 0">
                        <div class="section-header">
                            <span class="color-block"></span>图片
                        </div>
                        <div class="section-content">
                            <div class="pic-container">
                                <image-previewer :images="photo" tag="span"></image-previewer>
                            </div>
                        </div>
                    </div>
                    <div class="section" v-if="hasVideo">
                        <div class="section-header">
                            <span class="color-block"></span>视频

                        </div>
                        <div class="section-content">
                            <div class="video-container">
                                <video class="video" id="video" preload="auto"></video>
                            </div>
                        </div>
                    </div>
                    <div class="section" v-if="status !== 1">
                        <div class="section-header">
                            <span class="color-block"></span>处理信息
                        </div>
                        <div class="section-content">
                            {{batchContent}}
                            <div class="batch-info">
                                <span v-if="source === 1" class="status">{{['', '', '已处理', '已通知'][status]}}</span>
                                <span v-else class="status">{{['', '', '已处理', '已处理'][status]}}</span>
                                <span class="batch-time">{{batchTime | trimTime}}</span>
                                <span class="batch-user">{{batchUserName}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="处理"
            :visible.sync="isBatchDialogShow"
            width="30%"
            :before-close="dialogCancel">
            <div>
                <el-form :model="queryForm" label-width="80px" :rules="formRule" ref="form" class="form">
                    <el-form-item label="处理信息" prop="batchContent">
                        <el-input type="textarea" :maxlength="500" v-model="queryForm.batchContent" :rows="5" placeholder="请输入处理信息描述"></el-input>
                    </el-form-item>
                </el-form>
                <div v-if="queryForm.batchContent !== null && queryForm.batchContent !== undefined" class="word-count">
                    {{queryForm.batchContent.length}}/500
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogCancel">取 消</el-button>
                <el-button type="primary" @click="batchSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {getTrainRecordById, batchTrainRecord} from '@/api/affairs/affairs';
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer';

    export default {
        name: "messageDetail",
        data: function () {
            return {
                queryForm: {
                    batchContent: '',
                    batchType: 1
                },
                formRule: {
                    batchContent: [{
                        required: true,
                        message: '处理信息不能为空',
                        trigger: 'blur'
                    }]
                },
                id: this.$route.query.id,
                messageId: this.$route.query.messageId,
                createUserName: '',
                mobile: '',
                createTime: '',
                batchContent: '',
                batchUserName: '',
                batchTime: '',
                status: 1,
                photo: [],
                content: '',
                dictionaryCode: '',
                dictionaryName: '',
                tcPlayer: null,
                video: {
                    videoUrl: '',
                    videoId: ''
                },
                source: 2,
                hasVideo: true,
                isBatchDialogShow: false,

                containerHeight: 0
            }
        },
        mounted() {
            this.containerHeight = window.innerHeight - 350;
            getTrainRecordById({
                recordId: this.messageId
            })
                .then(res => res.data)
                .then(data => {
                    if (data.result) {
                        const pageData = data.data;
                        this.content = pageData.content;
                        this.dictionaryCode = pageData.dictionaryCode;
                        this.dictionaryName = pageData.dictionaryName;
                        this.photo = JSON.parse(pageData.photoJson).map(item => ({
                            src: item.fileUrl || item
                        }));
                        this.video = JSON.parse(pageData.videoJson);
                        const hasVideo = JSON.parse(pageData.videoJson).videoUrl !== '';
                        this.createUserName = pageData.createUserName;
                        this.mobile = pageData.mobile;
                        this.createTime = pageData.createTime;
                        this.queryForm.batchContent = pageData.batchContent || '';
                        this.batchContent = pageData.batchContent || '';
                        this.batchUserName = pageData.batchUserName;
                        this.batchTime = pageData.batchTime;
                        this.hasVideo = hasVideo;
                        this.status = pageData.status;
                        this.source = pageData.source;
                        if (hasVideo) {
                            this.initTcPlayer();
                        }
                    }
                });
        },
        components: {ImagePreviewer},
        filters: {
            trimTime(datetime) {
                return datetime.slice(0, datetime.lastIndexOf('.'));
            }
        },
        beforeDestroy() {
            if (this.hasVideo) {
                this.destroyTcPlayer();
            }
        },
        methods: {
            dialogCancel() {
                this.isBatchDialogShow = false;
                this.queryForm.batchContent = '';
            },
            showDialog(batchType) {
                this.isBatchDialogShow = true;
                this.queryForm.batchType = batchType;
            },
            notify() {
                this.$confirm('是否通知提交人?', '通知', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchTrainRecord({
                        id: this.messageId,
                        batchType: 3,
                        status: 3,
                        batchContent: this.queryForm.batchContent
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    type: 'success',
                                    message: '通知成功'
                                });
                                setTimeout(() => {
                                    this.$router.back();
                                }, 500);
                            }
                        })
                });

            },
            batchSubmit() {
                this.$refs.form.validate((isValid) => {
                    if(isValid) {
                        batchTrainRecord({
                            id: this.messageId,
                            batchType: this.queryForm.batchType,
                            status: ['', 2, 3, 3][this.queryForm.batchType],
                            batchContent: this.queryForm.batchContent
                        })
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message({
                                        type: 'success',
                                        message: '处理成功'
                                    });
                                    setTimeout(() => {
                                        this.$router.back();
                                    }, 500);
                                }
                            })
                    }
                });
            },
            jumpToPage(path, query) {
                this.$router.push({
                    path,
                    query
                })
            },
            initTcPlayer() {
                setTimeout(() => {
                    // const videoExt = this.videoUrl.match(/^.+\.(.+)$/)[1];
                    // const typeObj = {};
                    // typeObj[videoExt] = this.videoUrl;
                    console.log(this.video.videoId);
                    this.tcPlayer = TCPlayer('video',
                        {
                            "autoplay": false,      //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                            "coverpic": {
                                "style": "stretch",
                                "src": ''
                            },
                            "width": '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                            "height": '100%',//视频的显示高度，请尽量使用视频分辨率高度
                            fileID: this.video.videoId, // 请传入需要播放的视频filID 必须
                            appID: '1251008840', // 请传入点播账号的appID 必须,
                            controlBar: {
                                playbackRateMenuButton: false,
                                fullscreenToggle: false,
                                QualitySwitcherMenuButton: false
                            }
                        });
                }, 500);
            },

            destroyTcPlayer() {
                if (this.tcPlayer) {
                    this.tcPlayer.dispose();
                    this.tcPlayer = null;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../commonsPC/styles/mixins";

    .page {
        box-sizing: border-box;
        height: 670px;
        background-color: #F1F1F1;
    }
    .page-inner {
        background-color: #fff;
        width: 1200px;
        margin: 0 auto;
        padding: 20px;
    }

    .page-main {
        padding: 20px 0 0 0;
    }
    .container {
        height: 100%;
        overflow-y: auto;
    }

    .section {
        margin-bottom: 20px;
    }
    .section-content {
        word-break: break-all;
    }

    .section-header {
        font-size: 20px;
        margin-bottom: 20px;
        font-weight: bold;

        .color-block {
            @include middleIB;
            @include wh(5px, 20px);
            margin-right: 10px;
            background-color: #409EFF;
        }
    }

    .video {
        width: 600px;
        height: 300px;
    }
    .batch-info {
        margin-top: 10px;
        & > * {
            @include middleIB;
            margin-right: 20px;
            font-size: 14px;
            color: #666;
        }
    }
    .word-count {
        text-align: right;
    }
</style>
<style lang="scss">
    @import "../../../../commonsPC/styles/mixins";

    #affairMessageDetail .pic-container .images {
        @include wh(80px, 80px);
        @include middleIB;
        margin-right: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/views/affairs/messageDetail.vue